<template>


    <form-with-base-message ref="form" :base-errors="getErrorForField('base')"
                            class="container_form"
                            translations-scope="Login"
                            :success-message="successMessage">

        <v-container fluid>
            <v-layout row wrap>

                <template v-if="!cellVerified">
                    <v-flex xs12>
                        <v-container ma-0 pa-0 fluid>
                            <v-layout row wrap>
                                <v-flex mb-3 xs12
                                        class="primary--text title-font">
                                    {{$vuetify.t('$vuetify.NewAccount.cell_verification_process')}}
                                </v-flex>
                                <v-flex xs12>
                                    <v-select
                                            :items="getAvaiableLanguage()"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.languagePlaceholder')"
                                            color="secondary"
                                            background-color="primary"
                                            name="language"
                                            solo
                                            :error-messages="getErrorForField('language')"
                                            label="Box style"
                                            v-model="user.language"
                                            @change="changeCurrentLanguage()"
                                            @focus="resetErrorForField('language')"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <vue-tel-input
                                            ref="phoneInput"
                                            class="secondary--text flex-row-mobile-phone flex-row pt-2 pb-2 v-input v-text-field v-text-field--single-line v-text-field--solo v-text-field--enclosed v-text-field--placeholder theme--light v-input__slot primary"
                                            name="mobilePhone"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.mobilePhonePlaceholder')"
                                            @input="onPhoneInput()"
                                            :preferredCountries="['IT','ES','DE','FR','GB']"
                                            v-model="smsVerification.mobilePhone">
                                    </vue-tel-input>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn block
                                           class="eco-button"
                                           color="button-light"
                                           type="button"
                                           :disabled="!enableSmsRequestCode"
                                           @click.prevent="requestSmsCode()"
                                           large>
                                        {{$vuetify.t('$vuetify.NewAccount.sms_code_request')|uppercase}}
                                    </v-btn>
                                </v-flex>
                                <v-flex v-if="verificationCodeSent" xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.smscodePlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            v-model="smsVerification.code"
                                            @focus="$set(errors,'base', null)"
                                            name="code">
                                    </v-text-field>
                                </v-flex>

                                <v-flex v-if="verificationCodeSent" xs12>
                                    <v-btn block
                                           class="eco-button"
                                           color="button-light"
                                           type="button"
                                           @click="executePhoneVerification()"
                                           large>
                                        {{$vuetify.t('$vuetify.NewAccount.check_phone_number')|uppercase}}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </template>

                <template v-else>
                    <v-flex xs12>
                        <v-container ma-0 pa-0 fluid>
                            <v-layout row wrap>
                                <v-flex mb-3 xs12
                                        class="primary--text title-font">
                                    {{$vuetify.t('$vuetify.NewAccount.newUser')}}
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.firstname"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.namePlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            :error-messages="getErrorForField('firstname')"
                                            @focus="resetErrorForField('firstname')"
                                            name="firstname">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.lastname"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.surnamePlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            :error-messages="getErrorForField('lastname')"
                                            @focus="resetErrorForField('lastname')"
                                            name="lastname">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                      v-model="user.birth_date"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      type="date"
                                      :error-messages="getErrorForField('birth_date')"
                                      @focus="resetErrorForField('birth_date')"
                                      name="birthdate">
                                    <template v-slot:prepend-inner>
                                      <span class="placeholder-date">{{$vuetify.t('$vuetify.NewAccount.birthDatePlaceholder')}}</span>
                                    </template>
                                  </v-text-field>
                                </v-flex>
                                <!--                                <v-flex xs12>-->
                                <!--                                    <v-text-field-->
                                <!--                                            autocomplete="new-password"-->
                                <!--                                            v-model="user.telephone1"-->
                                <!--                                            :placeholder="$vuetify.t('$vuetify.NewAccount.phonePlaceholder')"-->
                                <!--                                            background-color="primary"-->
                                <!--                                            color="secondary"-->
                                <!--                                            solo-->
                                <!--                                            :error-messages="getErrorForField('telephone1')"-->
                                <!--                                            @focus="resetErrorForField('telephone1')"-->
                                <!--                                            name="telephone1">-->
                                <!--                                    </v-text-field>-->
                                <!--                                </v-flex>-->
                                <v-flex xs12>
                                  <v-text-field
                                      autocomplete="new-password"
                                      v-model="user.residenceAddress"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceAddressPlaceholder')"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      :error-messages="getErrorForField('residence_address')"
                                      @focus="resetErrorForField('residence_address')"
                                      name="residenceAddress">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                      autocomplete="new-password"
                                      v-model="user.residenceNumber"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceNumberPlaceholder')"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      :error-messages="getErrorForField('residence_number')"
                                      @focus="resetErrorForField('residence_number')"
                                      name="residenceNumber">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                      autocomplete="new-password"
                                      v-model="user.residenceCap"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceCapPlaceholder')"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      :error-messages="getErrorForField('residence_cap')"
                                      @focus="resetErrorForField('residence_cap')"
                                      name="residenceCap">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                      autocomplete="new-password"
                                      v-model="user.residenceCity"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceCityPlaceholder')"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      :error-messages="getErrorForField('residence_city')"
                                      @focus="resetErrorForField('residence_city')"
                                      name="residenceCity">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-text-field
                                      autocomplete="new-password"
                                      v-model="user.residenceDistrict"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceDistrictPlaceholder')"
                                      background-color="primary"
                                      color="secondary"
                                      solo
                                      :error-messages="getErrorForField('residence_district')"
                                      @focus="resetErrorForField('residence_district')"
                                      name="residenceDistrict">
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                  <v-select
                                      :items="getAvaiableCountries()"
                                      :placeholder="$vuetify.t('$vuetify.NewAccount.residenceCountryPlaceholder')"
                                      color="secondary"
                                      background-color="primary"
                                      name="residenceCountry"
                                      solo
                                      :error-messages="getErrorForField('residence_country')"
                                      label="Box style"
                                      v-model="user.residenceCountry"
                                      @focus="resetErrorForField('residence_country')"
                                  ></v-select>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.nationalIdentificationNumber"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.nationalIdentificationNumberPlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            @input="user.nationalIdentificationNumber = user.nationalIdentificationNumber.toUpperCase()"
                                            :error-messages="getErrorForField('national_identification_number')"
                                            @focus="resetErrorForField('national_identification_number')"
                                            name="nationalIdentificationNumber">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.email"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.emailPlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            :error-messages="getErrorForField('email')"
                                            @focus="resetErrorForField('email')"
                                            name="email">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.badge"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.badgePlaceholder')"
                                            background-color="primary"
                                            color="secondary"
                                            solo
                                            :error-messages="getErrorForField('badge')"
                                            @focus="resetErrorForField('badge')"
                                            name="badge">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>

                    <v-flex xs12>
                        <v-container ma-0 pa-0 fluid>
                            <v-layout row wrap>
                                <v-flex mb-3 xs12
                                        class="primary--text title-font">
                                    {{$vuetify.t('$vuetify.NewAccount.infoAccess')}}
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="user.username"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.usernamePlaceholder')"
                                            background-color="primary"
                                            color="seconary"
                                            solo
                                            :error-messages="getErrorForField('username')"
                                            @focus="resetErrorForField('username')"
                                            name="username">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            ref="password"
                                            :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
                                            name="password"
                                            v-model="user.password"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.passwordPlaceholder')"
                                            background-color="primary"
                                            solo
                                            :error-messages="getErrorForField('password')"
                                            color="secondary"
                                            :type="show_password ? 'text' : 'password'"
                                            @focus="resetErrorForField('password')"
                                            @click:append="toggle_password">


                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="new-password"
                                            ref="passwordConfirmation"
                                            :append-icon="show_password_confirmation ? 'mdi-eye-off' : 'mdi-eye'"
                                            name="passwordConfirmation"
                                            v-model="user.passwordConfirmation"
                                            :placeholder="$vuetify.t('$vuetify.NewAccount.passwordConfirmationPlaceholder')"
                                            background-color="primary"
                                            solo
                                            :error-messages="getErrorForField('password_confirmation')"
                                            color="secondary"
                                            :type="show_password_confirmation ? 'text' : 'password'"
                                            @focus="resetErrorForField('password_confirmation')"
                                            @click:append="toggle_password_confirmation">


                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-checkbox
                                            color="primary"
                                            v-model="privacyConsent"
                                            :error-messages="getErrorForField('gdpr_role')"
                                            @focus="resetErrorForField('gdpr_role')">
                                        <template #label>
                                            <span @click.stop="showPopupPrivacy= true">{{$vuetify.t('$vuetify.NewAccount.privacyConsent')}}</span>
                                        </template>
                                    </v-checkbox>
                                </v-flex>
                                <v-flex xs12>
                                    <v-checkbox
                                            color="primary"
                                            v-model="regulationAcceptance"
                                            :error-messages="getErrorForField('regulation_acceptance')"
                                            @focus="resetErrorForField('regulation_acceptance')">
                                        <template #label>
                                            <span @click.stop="showPopupRegulation= true">{{$vuetify.t('$vuetify.NewAccount.regulationAcceptance')}}</span>
                                        </template>
                                    </v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>

                    <v-flex xs12>
                        <v-btn block class="eco-button"
                               color="button-light"
                               type="submit"
                               large
                               @click.prevent="executeSubscribe()">
                            {{$vuetify.t('$vuetify.NewAccount.Register')|uppercase}}

                        </v-btn>
                    </v-flex>

                    <apollo-query client-id="clientPublic"
                                  :query="require('../graphql/queries/currentPublicCustomer.gql')">

                        <template
                                v-slot="{ result: { error, data }, isLoading }">


                            <v-dialog
                                    v-model="showPopupPrivacy"
                                    width="100%">
                                <v-card>

                                    <v-card-text v-if="data"
                                                 v-html="data.customer.privacy"
                                                 class="text-xs-justify">
                                    </v-card-text>

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="accent"
                                               flat
                                               @click="showPopupPrivacy = false">
                                            {{$vuetify.t("$vuetify.NewAccount.closePopupPrivacy")}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-dialog
                                    v-model="showPopupRegulation"
                                    width="100%">
                                <v-card>
                                    <v-card-text v-if="data"
                                                 v-html="data.customer.bikeSharingRoles"
                                                 class="text-xs-justify">
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="accent"
                                               flat
                                               @click="showPopupRegulation = false">
                                            {{$vuetify.t("$vuetify.NewAccount.closePopupRegulation")}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>


                        </template>
                    </apollo-query>
                </template>

              <SharedLoginButtons></SharedLoginButtons>
            </v-layout>
        </v-container>


    </form-with-base-message>


</template>


<script>

    import FormWithBaseMessage from "../components/FormWithBaseMessage"
    import webappUri from "../mixins/webappUri"
    import formValidation from "../mixins/formValidation"
    import availableLanguage from "../mixins/availableLanguage"
    import availableCountries from "../mixins/availableCoutries"
    import _ from "lodash"
    import SharedLoginButtons from "../components/SharedLoginButtons";


    export default {
        data: function () {

            return {
                smsVerification: {
                    mobilePhone: "",
                    mobilePhoneNumber: "",
                    mobilePhonePrefix: "",
                    code: ""

                },
                user: {
                    firstname: "",
                    lastname: "",
                    birth_date: "",
                    //telephone1: "",
                    nationalIdentificationNumber: "",
                    email: "",
                    badge: "",
                    language: "IT",
                    username: "",
                    password: "",
                    passwordConfirmation: "",
                    residenceAddress: "",
                    residenceNumber: "",
                    residenceCap: "",
                    residenceCity: "",
                    residenceDistrict: "",
                    residenceCountry: "",
                },
                privacyConsent: false,
                regulationAcceptance: false,
                successMessage: {},
                errors: {},
                show_password: false,
                show_password_confirmation: false,
                showPopupRegulation: false,
                showPopupPrivacy: false,
                enableSmsRequestCode: false,
                cellVerified: false,
                verificationCodeSent: false,
                executeVerifyCellquery: false

            }
        },
        mixins: [webappUri, formValidation, availableLanguage, availableCountries],
        methods: {
            toggle_password() {
                this.show_password = !this.show_password
            },
            toggle_password_confirmation() {
                this.show_password_confirmation = !this.show_password_confirmation
            },
            executeSubscribe() {
                this.errors = {}


                const USER_SUBSCRIPTION = require("../graphql/mutations/subscribeUser.gql")
                this.$apollo.mutate({
                    client: "clientPublic",
                    // Query
                    mutation: USER_SUBSCRIPTION,
                    // Parameters
                    variables: {
                        firstname: this.user.firstname,
                        lastname: this.user.lastname,
                        language: this.user.language,
                        birth_date: this.user.birth_date,
                        //telephone1: this.user.telephone1,
                        email: this.user.email,
                        badge: this.user.badge,
                        password: this.user.password,
                        password_confirmation: this.user.passwordConfirmation,
                        residence_address: this.user.residenceAddress,
                        residence_number: this.user.residenceNumber,
                        residence_cap: this.user.residenceCap,
                        residence_city: this.user.residenceCity,
                        residence_district: this.user.residenceDistrict,
                        residence_country: this.user.residenceCountry,
                        nationalIdentificationNumber: this.user.nationalIdentificationNumber,
                        webAppConfirmationUri: this.getWebAppConfirmationUri("confirm-account"),
                        username: this.user.username,
                        regulationAcceptance: this.regulationAcceptance,
                        gdprRole: this.privacyConsent,
                        sms_code: this.smsVerification.code,
                        mobile_number: this.smsVerification.mobilePhoneNumber,
                        mobile_prefix: this.smsVerification.mobilePhonePrefix,


                    },

                }).then((result) => {

                    result = result.data.subscribe


                    if (result._response.result) {

                        this.$refs.form.resetForm()
                        this.successMessage = {
                            title: this.$vuetify.t("$vuetify.NewAccount.subscribeSuccesfullyTitle"),
                            text: this.$vuetify.t("$vuetify.NewAccount.subscribeSuccesfully")
                        }
                        setTimeout(() => {

                            this.$router.push({name: "login"})
                        }, 3200)

                    } else {
                        this.errors = this.collectErrors(result._response.errors, "NewAccount")

                    }


                }).catch((error) => {
                    console.log(error)

                    //TODO implementare catch globale errori

                })


            },
            changeCurrentLanguage() {
              this.setGlobalCurrentLanguage(this.user.language);
            },
            assignPrefixAndNumber() {
                const phoneObj = this.$refs.phoneInput.phoneObject
                const countryDialCode = phoneObj.country.dialCode
                const number = phoneObj.number.significant

                this.smsVerification.mobilePhoneNumber = number
                this.smsVerification.mobilePhonePrefix = `+${countryDialCode}`
            },
            requestSmsCode() {
                this.verificationCodeSent = false
                this.enableSmsRequestCode = false

                if (this.checkPhoneNumberValidity()) {
                    //resetto gli errori precedenti
                    this.$set(this.errors, "base", null)
                    const SMS_CODE_REQUEST_MUTATION = require("../graphql/mutations/smsSendCode.gql")

                    this.$apollo.mutate({
                        client: "clientPublic",
                        // Query
                        mutation: SMS_CODE_REQUEST_MUTATION,
                        // Parameters
                        variables: {
                            input: {
                                mobilePhonePrefix: this.smsVerification.mobilePhonePrefix,
                                mobilePhoneNumber: this.smsVerification.mobilePhoneNumber,
                            }
                        },

                    }).then((result) => {
                        result = result.data.sendSmsCode.result

                        if (result.sendVerificationCode) {
                            this.verificationCodeSent = true
                        }

                    }).catch((error) => {
                        console.log(error)
                        //TODO implementare default error catcher
                        // Error
                        //console.error(error)
                    })

                } else {
                    this.printPhoneInputInvalidError()
                }


            },
            executePhoneVerification() {

                if (this.checkPhoneNumberValidity()) {
                    this.executeVerifyCellquery = true
                } else {
                    this.printPhoneInputInvalidError()
                }

            },
            onPhoneInput() {
                this.assignPrefixAndNumber()

                //riabilito la possibilità di richiedere sms
                this.enableSmsRequestCode = true

                //resetto gli errori relativi al phone input
                this.$set(this.errors, "base", null)
            },
            getSmsCodeErrors() {

            },
            checkPhoneNumberValidity() {
                const phoneObj = this.$refs.phoneInput.phoneObject
                return phoneObj.isValid
            },
            printPhoneInputInvalidError() {
                this.$set(this.errors, "base", [this.$vuetify.t("$vuetify.NewAccount.invalidPhoneNumber")])
            }

        },
        activated() {
            this.cellVerified = false
            this.smsVerification.code = ""
        },
        apollo: {
            smsCodeConfirmation: {
                query: require("../graphql/queries/sms_code_confirmation.gql"),
                variables() {
                    return {
                        number: this.smsVerification.mobilePhoneNumber,
                        prefix: this.smsVerification.mobilePhonePrefix,
                        code: this.smsVerification.code
                    }
                },
                manual: true,
                skip() {
                    return !this.executeVerifyCellquery
                },
                result(result, key) {
                    this.cellVerified = result.data.smsCodeConfirmation

                    if (!result.data.smsCodeConfirmation) {
                        this.$set(this.errors, "base", [this.$vuetify.t("$vuetify.NewAccount.invalidSmsCode")])
                    }


                    //interrompo la query fino al prossimo tap su verifica codice
                    this.executeVerifyCellquery = false
                }

            }
        },
        components: {
            FormWithBaseMessage,
            SharedLoginButtons
        }
    }
</script>


<style lang="scss">
    .container_form {
        margin: auto 30px !important;
        overflow: hidden;


        .v-label {
            color: var(--v-primary-base) !important;
        }

        & /deep/ .mdi-checkbox-blank-outline {

            &:before {
                color: var(--v-primary-base)
            }
        }
    }


</style>

<style scoped lang="scss">

    .container_form {


        & /deep/ .mdi-checkbox-blank-outline {

            &:before {
                color: var(--v-primary-base)
            }
        }
    }

    .flex-row-mobile-phone {
        flex-direction: row;
        flex-wrap: nowrap;
        border: none;
        border-radius: 0;

        & /deep/ .vti__dropdown {
            position: static;
        }

        & /deep/ .vti__dropdown-list {
            width: 100%;
            left: 0px;
            top: 100%;
            padding: 10px 0px;
        }
    }

    .phone-input-errors {
        color: var(--v-error-base) !important;
        caret-color: var(--v-error-base) !important;
        text-align: left;
        font-size: 12px;
        padding: 0 12px;
        margin-top: 8px;
    }

    .eco-button.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
        background-color: var(--v-button-light-base) !important;
        border-color: var(--v-button-light-base) !important;
        opacity: 0.4;
        color: var(--v-primary-base) !important;
    }

    .placeholder-date{
      color: #c4cece;
    }

</style>
